import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableExtraParams } from 'projects/common/src/app/interfaces/table/table-extra-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';

@Component({
  selector: 'app-report-explosive-modal',
  templateUrl: './report-explosive-modal.component.html',
  styleUrls: ['./report-explosive-modal.component.scss'],
})
export class ReportExplosiveModalComponent implements OnInit {
  @Input() public data;
  @Input() public zoneName;
  public tableConfig: ITableConfig;
  public dataMapped: any;
  constructor(private tableService: TableConfigService, public activeModal: NgbActiveModal, private languageService: LanguageService) {}

  /**
   * Init Component
   */
  public ngOnInit(): void {
    this.mappedData();
  }

  /**
   * mappedData
   */
  public mappedData(): void {
    const mappedZoneName = this.data.find((m) => m.zoneName === this.zoneName);
    const filterData = mappedZoneName.explosiveConditionHistory.filter((f) => f.zoneName);
    const tableData = [];
    for (const explosive of filterData) {
      tableData.push({
        zoneId: explosive.zoneId,
        zoneName: explosive.zoneName,
        conditionName: explosive.conditionName,
        conditionSourceName: explosive.conditionSourceName,
        conditionDate: explosive.conditionDate,
        apD450: explosive.apD450,
        apD900: explosive.apD900,
        apD1500: explosive.apD1500,
        tronex: explosive.tronex,
        barraFCK: explosive.barraFCK === false ? 'NO' : 'SI',
        detonadores: explosive.detonadores,
        famebat: explosive.famebat,
        famepast: explosive.famepast,
        operatorName: explosive.operatorName,
        lastRegister:
          explosive.lastRegister === 0 ? this.languageService.message('data-modified') : this.languageService.message('data-actual'),
      });
    }
    this.setConfigHistory(tableData);
  }

  /**
   * setConfig table History explosive
   */
  public setConfigHistory(tableData: any): void {
    const excludeColumns = ['zoneId', 'conditionSourceId', 'conditionId', 'conditionLogSyncId'];
    const extraParams: ITableExtraParams = {
      extraWide: true,
    };
    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns,
      replaceColumnName: [
        { prevName: 'zoneName', newName: 'zone' },
        { prevName: 'conditionName', newName: 'spot condition' },
        { prevName: 'conditionSourceName', newName: 'profile_group' },
        { prevName: 'conditionDate', newName: 'date-condition' },
        { prevName: 'operatorName', newName: 'operator-user' },
        { prevName: 'barraFCK', newName: 'barrafck' },
        { prevName: 'lastRegister', newName: 'last_update' },
      ],
    };

    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns,
      dateConfig: [
        { field: 'conditionDate', format: 'date-time' },
        { field: 'createdAt', format: 'date-time' },
      ],
    };

    const header = this.tableService.setHeaderConfig(headerParams);
    const dataset = this.tableService.setDatasetConfig(datasetParams);

    this.tableConfig = { header, dataset, extraParams };
  }
}
